module.exports = "<div class=\"faq-list hide\"> <p> <%= faq %> </p> <div class=faq-list-content></div> </div> ";